<template>
  <div style="height: 100%">
    <div class="headers_box flex flex_items_center">
      <el-menu
        @select="handleSelect"
        :text-color="'#fff'"
        :background-color="'rgba(0, 0, 0, 0.8)'"
        :active-text-color="'#fff'"
        :default-active="activeIndex"
        collapse-transition
        class="el-menu-middle moblie-menu"
        mode="horizontal"
        menu-trigger="hover"
        ref="kzMenu"
      >
        <template v-for="(item, index) in menuArr">
          <!-- 有子菜单 -->
          <el-submenu
            popper-class="test"
            v-if="item.children"
            :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            :key="index"
            :show-timeout="100"
          >
            <template slot="title">
              <span>{{ langSet == "cn" ? item.name_cn : item.name_en }}</span>
            </template>

            <template v-for="(n, i) in item.children">
              <el-menu-item
                v-if="
                  (n.name_cn.length > 0 && langSet == 'cn') ||
                  (n.name_en.length > 0 && langSet == 'en')
                "
                :key="i"
                :index="
                  langSet == 'cn'
                    ? n.http_url_cn !== '/download'
                      ? n.http_url_cn
                      : n.http_url_cn + '/' + n.id
                    : n.http_url_en !== '/download'
                    ? n.http_url_en
                    : n.http_url_en + '/' + n.id
                "
              >
                <template>
                  <span slot="title">{{
                    langSet == "cn" ? n.name_cn : n.name_en
                  }}</span>
                </template>
              </el-menu-item>
            </template>
          </el-submenu>
          <!-- 没有子菜单 -->
          <el-menu-item
            v-else
            :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
            :key="index"
          >
            <span slot="title">{{
              langSet == "cn" ? item.name_cn : item.name_en
            }}</span>
          </el-menu-item>
        </template>
      </el-menu>
      <template v-if="flag">
        <div
          class="header_login flex flex_items_center flex_content_center"
          :class="isShowInfo ? 'show' : ''"
          @click="showInfo"
        >
          <img :src="userInfo.avatar_uri" alt="" />
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="login_wrap" v-if="isShowInfo">
          <div class="login_top">
            <img :src="userInfo.avatar_uri" alt="" />
            <div class="login_info">
              <div class="name">
                {{ userInfo.nickname }}<span>{{ userInfo.position }}</span>
              </div>
              <div>{{ userInfo.company_name }}</div>
            </div>
          </div>
          <div class="login_middle">
            <div class="login_item" @click="toLink('/personal')">
              <img class="icon_a" src="../assets/icon_p.png" alt="" />
              <img class="icon_d" src="../assets/icon_pa.png" alt="" />
              <p>{{ langSet == "cn" ? "个人资料" : "Personal Information" }}</p>
            </div>
            <div class="login_item" @click="toLink('/mycollect')">
              <img class="icon_a" src="../assets/icon_c.png" alt="" />
              <img class="icon_d" src="../assets/icon_ca.png" alt="" />
              <p>{{ langSet == "cn" ? "我的收藏" : "My Favourite" }}</p>
            </div>
            <div class="login_item" @click="toLink('/mybusiness')">
              <img class="icon_a" src="../assets/icon_b.png" alt="" />
              <img class="icon_d" src="../assets/icon_ba.png" alt="" />
              <p>{{ langSet == "cn" ? "我的商机" : "My Business" }}</p>
            </div>
          </div>
          <div class="login_bottom">
            <div class="text" @click="handleDialogVisible">
              {{ langSet == "cn" ? "认证展商" : "Exhibition Certification" }}
            </div>
            <div @click="logOut">
              {{ langSet == "cn" ? "退出登录" : "Log Out" }}
            </div>
          </div>
        </div>
      </template>
    </div>
    <el-dialog
      width="400px"
      custom-class="exhibition_dialog"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :show-close="false"
      :z-index="3000"
    >
      <div class="dialog_wrap">
        <div class="dialog_title">
          {{ langSet == "cn" ? "展商认证" : "Exhibition Certification" }}
        </div>
        <el-form
          :model="companyForm"
          :rules="companyFormRules"
          ref="companyForm"
          label-width="80px"
          label-position="top"
          class="personal_form"
        >
          <el-form-item
            :label="langSet == 'cn' ? '账号' : 'Account number'"
            prop="username"
          >
            <el-input
              v-model="companyForm.username"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '密码' : 'Password'"
            prop="password"
          >
            <el-input
              v-model="companyForm.password"
              type="password"
              placeholder="请输入"
            ></el-input>
            <div class="dialog_tips">
              {{
                langSet == "cn"
                  ? "请向您企业展会负责人所要验证信息"
                  : "Please request verifcation information from the person in charge of your company's exhibition"
              }}
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitCompanyForm('companyForm')"
              >{{ langSet == "cn" ? "提交" : "Submit" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { webMenu, userInfo, logout, companyAttestation } from "@/api/api";
import de from "element-ui/src/locale/lang/de";

export default {
  data() {
    return {
      menuArr: [],
      langSet: "",
      userInfo: {},
      flag: "",
      isShowInfo: false,
      dialogVisible: false,
      companyForm: {
        username: "",
        password: "",
      },
      companyFormRules: {
        username: [
          {
            required: true,
            message: "请输入账号/please enter account number",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码/please enter password",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
  },
  mounted() {
    this.langSet = this.$language;
    this.getMenu();
    // 25.6.13 获取个人资料 dxm
    this.flag = localStorage.getItem("Flag") || "";
    if (this.flag == "isLogin") {
      this.getUserInfo();
    }
  },
  computed: {
    activeIndex() {
      const { name, fullPath } = this.$route;
      let rout = "";
      rout = this.$route.fullPath;
      return rout;
    },
  },
  methods: {
    handleDialogVisible() {
      this.dialogVisible = true;
    },
    startsWithSlash(str) {
      return /^\//.test(str);
    },
    showInfo() {
      this.isShowInfo = !this.isShowInfo;
    },
    isPDF(fileName) {
      if (!fileName) return false;
      // 获取后缀
      const suffix = fileName.split(".").pop().toLowerCase();
      // PDF后缀列表
      const pdfExtensions = ["pdf"];
      return pdfExtensions.includes(suffix);
    },
    handleSelect(key, keyPath) {
      if (key) {
        if (this.startsWithSlash(key)) {
          this.$router.push({
            path: key,
          });
        } else {
          if (key == 0) {
            this.$emit("changjqqd");
          } else {
            let path = key;
            window.open(path, "_blank");
          }
        }
      }
    },
    getMenu() {
      let arr = [];
      let data = {
        page_type: 0,
      };
      webMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let lists = res.data.lists;
            localStorage.setItem("menuArr", JSON.stringify(lists));
            lists.map((item, index) => {
              if (item.is_top == "是") {
                arr.push(item);
              }
            });
            this.menuArr = arr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getUserInfo() {
      try {
        const res = await userInfo();
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      } catch (error) {
        let loginRes = {
          token: null,
          isLogin: false,
        };
        this.$store.commit("userStatus", loginRes);
        localStorage.clear();
        setTimeout(() => {
          location.reload();
        }, 500);
      }
    },
    toLink(path) {
      this.$router.push({
        path,
      });
    },
    //退出登录
    async logOut() {
      try {
        await this.$confirm("确定要退出吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await logout();
        this.$message.success("退出成功");
        let loginRes = {
          token: null,
          isLogin: false,
        };
        this.$store.commit("userStatus", loginRes);
        localStorage.clear();
        setTimeout(() => {
          this.$router.push({
            path: "/",
          });
          location.reload();
        }, 2000);
      } catch (err) {
        if (err !== "cancel") {
          this.$message.error("退出失败: " + err.message);
        }
      }
    },
    async submitCompanyForm(formName) {
      this.loading = true;
      try {
        const valid = await new Promise((resolve) => {
          this.$refs[formName].validate(resolve);
        });
        if (valid) {
          await companyAttestation(this.companyForm);
          this.$message.success("认证成功");
          this.dialogVisible = false;
        } else {
          this.$message.error("认证失败，请检查输入信息");
          return false;
        }
        this.loading = false;
      } catch (err) {
        this.$message.error(`提交失败: ${err.message}`);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog {
  z-index: 3000 !important;
}
.headers_box {
  height: 100%;
  padding-right: 20px;
  position: relative;
  .header_login {
    width: 109px;
    height: 49px;
    color: #fff;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 5px;
      border-radius: 50%;
    }
    .el-icon-arrow-right {
      transition: all 0.3s;
    }
  }
  .show .el-icon-arrow-right {
    transform: rotate(90deg);
  }
  .login_wrap {
    width: 360px;
    height: auto;
    background: #fff;
    position: absolute;
    top: 88px;
    right: -130px;
    font-size: 14px;
    color: #898b9b;
    line-height: 20px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
    }
    .login_top {
      height: 96px;
      color: #fff;
      background: #004190;
      box-sizing: border-box;
      img {
        width: 65px;
        height: 65px;
        border-radius: 50%;
        margin-right: 11px;
      }
      .login_info {
        flex: 1;
        .name {
          font-size: 18px;
          font-weight: 500;
          margin-bottom: 5px;
          span {
            font-size: 15px;
            margin-left: 10px;
          }
        }
      }
    }
    .login_middle {
      margin: 0 14px;
      padding: 17px 10px;
      border-bottom: 1px solid #eee;
      > div {
        width: 80px;
        min-height: 80px;
        padding: 13px 0;
        box-sizing: border-box;
        text-align: center;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        .icon_a {
          display: none;
        }
        .icon_d {
          display: block;
        }
        &:hover {
          color: #fff;
          background: #719ed5;
          .icon_d {
            display: none;
          }
          .icon_a {
            display: block;
          }
        }
      }
      img {
        width: 26px;
        margin: 0 auto 8px;
      }
    }
    .login_bottom {
      padding: 15px 24px;
      > div {
        cursor: pointer;
      }
      .text {
        color: #004190;
      }
    }
  }
}
.headers_slide_box {
  height: 100%;
}
.dialog {
  width: 200000px;
  height: 288px;
  background: #ffffff;
  border-radius: 12px;
  margin: auto;
  display: flex;
}
.dialog_img {
  width: 500px;
  height: 160px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.el-menu {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 0 0 40px;
  box-sizing: border-box;
  align-items: center;
  background: transparent !important;
}
.el-menu-item {
  font-size: 20px;
  height: 100%;
  line-height: 25px;
  flex: 1;
  text-align: center;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .el-submenu__title {
  font-size: 20px;
  padding: 0 10px !important;
}
.el-submenu__title * {
  vertical-align: initial;
  white-space: break-spaces;
}
/deep/ .el-submenu__title i {
  display: none;
}
.el-menu.el-menu--horizontal,
.el-menu--horizontal > .el-menu-item {
  border-bottom: 0 none;
  background: transparent !important;
}
.headers_box .el-menu--horizontal > .el-menu-item:hover,
.headers_slide_box .el-menu--horizontal > .el-menu-item:hover {
  color: #000 !important;
}
.headers_box .el-menu--horizontal > .el-menu-item.is-active {
  color: #fff;
}
.headers_slide_box .el-menu--horizontal > .el-menu-item.is-active {
  color: #2c2c2e;
}
.el-menu-middle .el-menu-item,
.el-menu-middle .el-submenu__title {
  white-space: normal;
}
/deep/ .el-dialog__wrapper {
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999;
}
/deep/ .exhibition_dialog {
  height: 387px;
  margin-top: 0;
  background: #004190;
  border-radius: 20px;
  .el-dialog__body {
    color: #fff;
    padding: 0 30px;
  }
  .dialog_title {
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
  }
  .el-form-item__label {
    color: #fff;
    font-size: 16px;
    line-height: 22px;
  }
  .el-button--primary {
    width: 180px;
    font-size: 16px;
    background: #e62344;
    border-color: #e62344;
    border-radius: 5px;
    margin: 0 auto;
    display: block;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item__error {
    top: 10px;
    left: auto;
    right: 15px;
  }
  .dialog_tips {
    padding-top: 10px;
    line-height: 20px;
  }
}
@media only screen and (max-width: 1100px) {
  .el-menu-item {
    font-size: 17px;
    padding: 0 5px;
  }
  /deep/ .el-submenu__title {
    font-size: 17px;
  }
}
@media only screen and (max-width: 767px) {
  .el-menu {
    position: absolute;
    width: 100%;
  }
}
</style>
<style>
.el-submenu {
  flex: 1;
  display: flex;
  justify-content: center;
  /* text-align: center; */
  /* padding-right: 22px; */
}
.headers_box .el-menu--horizontal > .el-submenu .el-submenu__title {
  display: flex;
  align-items: center;
  line-height: 25px;
  justify-content: center;
  text-align: center;
  background: transparent !important;
}
.headers_box .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #fff;
  border-bottom: 0 none;
}
.headers_box .el-menu--horizontal > .el-submenu .el-submenu__title:hover,
.headers_box .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #000 !important;
}

.headers_slide_box .el-menu--horizontal > .el-submenu .el-submenu__title {
  display: flex;
  align-items: center;
  line-height: 25px;
  background: transparent !important;
}
.headers_slide_box
  .el-menu--horizontal
  > .el-submenu.is-active
  .el-submenu__title {
  color: #fff;
  border-bottom: 0 none;
}
.test {
  border: none !important;
}
/* 弹出的二级菜单 */
.test .el-menu--popup {
  width: 230px;
  position: relative;
  top: 14px;
  left: 20px;
  margin: 0;
  padding: 0;
}
/* 修改二级菜单整个背景颜色 */
.test .el-menu {
  background-color: rgba(0, 22, 48, 0.2) !important;
  /* box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.12); */
  border-radius: 0;
  backdrop-filter: blur(4px);
}
/* 二级菜单中的子选项 */
.test .el-menu .el-menu-item {
  background-color: transparent !important;
  /* color: rgba(255, 255, 255, 0.7) !important; */
  font-weight: 400;
  width: 100%;
  height: 50px;
  font-weight: 500;
  line-height: 50px;
  font-size: 14px;
  text-indent: 5px;
  justify-content: flex-start;
}
/* 被选择的子选项 */
.test .el-menu .el-menu-item:not(.is-disabled):hover {
  color: #000 !important;
  border-bottom-color: #2c2c2c !important;
  width: 100%;
  background: #fff !important;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: rgb(44, 44, 46);
  border-bottom-color: #2c2c2c !important;
}
</style>